const getBaseURL = () => {
  return window.location.origin.replace('app.', '');
};

export default getBaseURL;
